var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailUntop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2.6H2V1.4h12v1.2zM8.6 5.166l1.102.787-1.102.844V5.166zm.136-1.377l1.962 1.4 2.619-2.005.73.952-.096-.124-11.226 8.6-.634-.827L7.4 7.717V5.166L1.348 9.488.65 8.512l6.613-4.723a1.267 1.267 0 011.472 0zM7.4 10.29V15h1.2V9.37l-1.2.92zm4.04-3.095l3.211 2.293.698-.976-2.912-2.08-.997.763z",
    fill: "#3C3F47"
  })));
}
export default __webpack_public_path__ + "static/mail_untop.df6d8856.svg";
export { SvgMailUntop as ReactComponent };